export function convertToEnglishNumerals(input) {
    const englishDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  
    return input.replace(
      /[۰-۹]/g,
      (digit) => englishDigits[persianDigits.indexOf(digit)]
    );
  }
  
export async function register(formData) {
    let convertedNumber;

    const plan = "twinpeaks";
  
    if (formData.get("phone") && typeof formData.get("phone") == "string") {
      convertedNumber = convertToEnglishNumerals(formData.get("phone"));
    }
  
    const fields = {
      name: formData.get("fullName"),
      mobile: convertedNumber,
      plan :"twinpeaks"
    };
  
    if (fields.fullName?.length < 3 ) {
      return {
        status: false,
        message: "لطفا تمامی فیلدها را پر کنید",
        fields,
      };
    }
  
    if (fields.mobile?.length !== 11 || isNaN(Number(fields.mobile))|| 
    !fields.mobile.startsWith("09")) {
      return {
        status: false,
        message: "لطفا شماره موبایل را به درستی وارد کنید",
        fields,
      };
    }

    // const formdata = new FormData();
    // formdata.append("name", formData.get("fullName"));
    // formdata.append("mobile", convertedNumber);
    // formdata.append("plan", plan);


    // console.log(fields);
  
    try {
      const res = await fetch(`https://pakshoma.com/plan-users/submit`, {
        method: "POST",
        body:  JSON.stringify(fields),
        headers: {
          "Content-Type": "application/json",
          "Accept-Encoding": "gzip, deflate, br",
          Accept: "application/json",
        },
      });

      

      const response = await res.json();

      // console.log(response);
      

      return {
        result: response.result,
        message: response.message,
        fields,
      };
    } catch (error) {

      return {
        result: false,
        message: "خطایی رخ داده است",
        fields,
      };
    }
  }